import { Box, Shimmer, ShimmerText } from '@betterment/samba-react';

export const ListShimmer: React.FC = () => {
  return (
    <Box data-color-mode="dark">
      <Box
        css={{
          display: 'flex',
          flexDirection: 'row',
          gap: 'space.150',
          alignItems: 'center',
          py: 'space.150',
        }}
      >
        <Shimmer css={{ height: 'size.300', width: 'size.300', borderRadius: 'medium' }} />
        <ShimmerText textStyle="text25" css={{ width: '100px', flexShrink: 1 }} />
      </Box>
    </Box>
  );
};
